import { render, staticRenderFns } from "./place_analyses.vue?vue&type=template&id=204b8f0a&scoped=true&"
import script from "./place_analyses.vue?vue&type=script&lang=js&"
export * from "./place_analyses.vue?vue&type=script&lang=js&"
import style0 from "./place_analyses.vue?vue&type=style&index=0&id=204b8f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b8f0a",
  null
  
)

export default component.exports